/** Empty-state copy shared across screens. */
const dictionary = {
  "en": {
    "openPositions": {
      "title": "No open positions found?",
      "description": "Open a new open position and create the target profile for talent matching.",
      "cta": "Open a new position"
    },
    "noUsers": "No users found.",
    "noMembers": "No members found",
    "noCandidates": "No candidates found.",
    "noCandidateFound": "No candidate found",
    "noCompetences": "No competences at the moment",
    "noMotivationalFactors": "No motivational factors at the moment",
    "noData": "no data",
    "selectUserToEdit": "Please select a user to edit.",
    "home": {
      "cta": "Audit the team",
      "title": "There is no data to display.",
      "subtitle": "Start by auditing your team.",
      "description": "Audit your team to find your missing competencies or multiply your successful team players."
    }
  },
  "de": {
    "openPositions": {
      "title": "Keine offenen Positionen gefunden?",
      "description": "Eröffnen Sie eine neue Position und erstellen Sie das Zielprofil für das Talent-Matching.",
      "cta": "Neue Position erstellen"
    },
    "noUsers": "Keine passenden Personen gefunden.",
    "noMembers": "Keine Mitglieder gefunden",
    "noCandidates": "Keine passenden Personen gefunden.",
    "noCandidateFound": "Keine passende Person gefunden",
    "noCompetences": "Derzeit keine Kompetenzen",
    "noMotivationalFactors": "Derzeit keine Werte & Motive",
    "noData": "keine Daten",
    "selectUserToEdit": "Bitte wählen Sie eine Person zum Bearbeiten aus.",
    "home": {
      "title": "Es sind keine Daten vorhanden.",
      "subtitle": "Beginnen Sie mit einem Team-Audit.",
      "description": "Analysieren Sie Ihr Team, um fehlende Kompetenzen zu finden oder erfolgreiche Teammitglieder zu identifzieren.",
      "cta": "Team prüfen"
    }
  },
  "fi": {
    "openPositions": {
      "title": "Avoimia tehtäviä ei löytynyt",
      "description": "Avaa uusi tehtävä ja luo sille kohdeprofiili osaajien yhteensovitusta varten.",
      "cta": "Avaa uusi tehtävä"
    },
    "noUsers": "Käyttäjiä ei löytynyt.",
    "noMembers": "Jäseniä ei löytynyt",
    "noCandidates": "Hakijoita ei löytynyt.",
    "noCandidateFound": "Hakijaa ei löytynyt",
    "noCompetences": "Ei osaamisalueita tällä hetkellä",
    "noMotivationalFactors": "Ei motivaatiotekijöitä tällä hetkellä",
    "noData": "ei tietoja",
    "selectUserToEdit": "Valitse käyttäjä muokattavaksi.",
    "home": {
      "cta": "Kartoita tiimi",
      "title": "Näytettäviä tietoja ei ole.",
      "subtitle": "Aloita kartoittamalla tiimisi.",
      "description": "Kartoita tiimisi, niin löydät puuttuvat osaamisalueet tai saat lisää menestyviä tiimipelaajia."
    }
  }
};

export default dictionary;
